import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import React from 'react';

import { useOptions } from 'entities/pledgeAutoForm';

export const CarManufactureYear: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { years } = useOptions();

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={years}
    />
  );
};
